// extracted by mini-css-extract-plugin
export default {"top-box":"AllowAccess_top-box__AzjmR","li-box":"AllowAccess_li-box__j7SqX","bottom-box":"AllowAccess_bottom-box__+SGA1"};